<template>
  <div class="secondary d-flex flex-column" style="height: 100vh; width: 100vw">
    <v-btn @click="$emit('close')" icon class="ml-auto" style="">
      <v-icon color="white">mdi-close</v-icon>
    </v-btn>
    <div
      ref="achievementContent"
      class="achievement-content d-flex flex-column align-center justify-start pt-4 px-4 pb-2"
      :style="{ backgroundColor: $vuetify.theme.themes.light.secondary }"
    >
      <!-- Compact congratulations block (cropped to fit screen) -->
      <div class="congrats-block">
        <div class="medal-icon">🏅</div>
        <div class="body-2 white--text text-center congrats-message">
          {{ $t("general.achievement_dialog") }}
        </div>
        <div class="body-2 font-weight-bold mt-1 achievement-title">
          {{ achievementTitle }}
        </div>
        <v-img
          v-if="routeImageSrc"
          class="route-thumb mt-2"
          :src="routeImageSrc"
          aspect-ratio="1"
        ></v-img>
      </div>
    </div>

    <div class="d-flex justify-center pb-6">
      <v-btn @click="onShare" fab color="accent" class="mt-2">
        <v-icon color="white" size="25">mdi-share</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { decodeEntities } from "@/utils/decodeEntities";
import { Share } from "@capacitor/share";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { toBlob } from "html-to-image";

export default {
  props: {
    route: Object,
    areaName: {
      type: String,
      default: "",
    },
    dayNumber: {
      type: Number,
      default: null,
    },
  },

  computed: {
    routeImageSrc() {
      if (!this.route?.main_image) return "";
      const path = this.route.main_image.startsWith("/")
        ? this.route.main_image
        : "/" + this.route.main_image;
      return "https://iguide.mobics.gr" + path;
    },

    achievementTitle() {
      let title = decodeEntities(this.route?.name ?? "");
      if (this.dayNumber != null) {
        title += ` - ${this.$t("routes.day")} ${this.dayNumber}`;
      }
      if (this.areaName) {
        title += ` ${this.areaName}`;
      }
      return title;
    },

    shareText() {
      let text =
        this.$t("general.achievement_dialog") + " " + this.achievementTitle;
      return text;
    },
  },

  methods: {
    async onShare() {
      try {
        const element = this.$refs.achievementContent;

        // Get the background color from Vuetify theme
        const bgColor = this.$vuetify.theme.themes.light.secondary || "#1976D2";

        // Convert the HTML element to PNG blob
        const blob = await toBlob(element, {
          quality: 0.95,
          pixelRatio: 2,
          backgroundColor: bgColor,
          cacheBust: true,
          fontEmbedCSS: "",
        });

        // Convert blob to base64
        const reader = new FileReader();
        const base64 = await new Promise((resolve, reject) => {
          reader.onloadend = () => {
            const base64String = reader.result.split(",")[1];
            resolve(base64String);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        const filename = `achievement-${this.route?.id ?? "share"}.png`;
        await Filesystem.writeFile({
          path: filename,
          data: base64,
          directory: Directory.Cache,
        });

        const { uri } = await Filesystem.getUri({
          path: filename,
          directory: Directory.Cache,
        });

        await Share.share({
          title: this.achievementTitle,
          text: this.shareText,
          url: "https://ionianislands.net/explore/",
          files: [uri],
          dialogTitle: this.$t("general.achievement_dialog"),
        });
      } catch (e) {
        console.error("Error sharing achievement:", e);
        await Share.share({
          title: this.achievementTitle,
          text: this.shareText,
          url: "https://ionianislands.net/explore/",
          dialogTitle: this.$t("general.achievement_dialog"),
        });
      }
    },
  },
};
</script>

<style scoped>
.achievement-content {
  flex: 1;
  min-height: 0;
}

.medal-icon {
  font-size: 50px;
  line-height: 1;
  margin-bottom: 8px;
}

.congrats-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: calc(100vh - 180px);
  overflow: hidden;
}

.congrats-message {
  line-height: 1.3;
  max-height: 2.6em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.achievement-title {
  color: white !important;
  text-align: center;
  max-height: 3em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.4;
}

.route-thumb {
  width: 80vw;
  max-width: 100%;
  border-radius: 8px;
  flex-shrink: 0;
}
</style>
